import { MY_SUBSCRIPTIONS } from '../ids';
import { InstallLocation } from '../types';
export const ids = MY_SUBSCRIPTIONS;
export const getDefinition = (staticsUrl, t) => ({
    ...ids,
    installLocation: InstallLocation.Standalone,
    method: 'addApplication',
    social: false,
    showInLoginMenu: true,
    urlOverride: 'my-subscriptions',
    uninstallable: true,
    page: {
        name: t('editor.my-subscriptions-page.name'),
        shortDescription: t('editor.my-subscriptions-page.short-description'),
        description: t('editor.my-subscriptions-page.description'),
        iconURL: `${staticsUrl}/assets/images/icons/pricing-plans.png`,
        origin: t('editor.my-subscriptions-page.origin'),
        isNew: true,
        screenshots: [
            `${staticsUrl}/assets/images/my-subscriptions/my-subscriptions.png`,
            `${staticsUrl}/assets/images/my-subscriptions/my-subscriptions-2.png`,
            `${staticsUrl}/assets/images/my-subscriptions/mobile-my-subscriptions.png`,
            `${staticsUrl}/assets/images/my-subscriptions/mobile-my-subscriptions-2.png`,
        ],
    },
});
//# sourceMappingURL=my-subscriptions.js.map